// ── transcribe-on-demand (docs/specs/ondemand-1.md) ─────────────────────────────────────
// Mirrors the ONDEMAND-1 component schemas in openapi/scribe.yaml. Every endpoint except
// `getTranscriptionSettings` is a 404 unless the backend runs with
// SCRIBE_TRANSCRIBE_ON_DEMAND=1 — clients gate all UI on `TranscriptionSettings.feature_enabled`.
//
// No new RecordingStatus value: a DEFERRED recording is `status: 'uploaded'` +
// `audio_available: true` + `transcription_deferred_at` set (see `isDeferred`).
/** The `error.code` a transcript read returns (404) when it just started — or found in
 * flight — a transcription; `error.details.eta_seconds` says roughly when to retry. */
export const TRANSCRIPTION_PENDING_CODE = 'transcription_pending';
/** A deferred recording: audio stored, transcription waiting for someone to want it. */
export function isDeferred(recording) {
    return (recording.status === 'uploaded' &&
        recording.audio_available &&
        recording.transcription_deferred_at != null);
}
//# sourceMappingURL=ondemand.js.map